@if (records.length > 0) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Uptime</mat-card-title>
      <mat-card-subtitle>Last updated at {{ records[0].eventFormattedTime }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="content-wrapper">
        <div class="circle" [ngClass]="{ 'up-bg': records[0].state === '200', 'down-bg': records[0].state !== '200' }">
          <div class="circle-text">
            @if (records[0].state === '200') {
              <span class="site-up">
                <mat-icon class="site-status-icon up-icon">arrow_circle_up</mat-icon>
                <span class="site-status-text">UP</span>
              </span>
            }
            @if (records[0].state !== '200') {
              <span class="site-down">
                <mat-icon class="site-status-icon down-icon">arrow_circle_down</mat-icon>
                <span class="site-status-text">DOWN</span>
              </span>
            }
          </div>
        </div>
        <div class="site-report">
          <div class="report-text">
            <div class="report-text-title">Last 24 Hours</div>
            <div class="report-text-value">{{ last24Hrs }}%</div>
          </div>
          <div class="report-text">
            <div class="report-text-title">Last 7 Days</div>
            <div class="report-text-value">{{ last7Days }}%</div>
          </div>
          <div class="report-text">
            <div class="report-text-title">Last 30 Days</div>
            <div class="report-text-value">{{ last30Days }}%</div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Event Log</mat-card-title>
    </mat-card-header>
    @for (record of records | slice: 0 : 3; track record) {
      <div class="event-log">
        <div>
          @if (record.state === '200') {
            <mat-icon class="log-icon up-icon">arrow_circle_up</mat-icon>
          }
          @if (record.state !== '200') {
            <mat-icon class="log-icon down-icon">arrow_circle_down</mat-icon>
          }
        </div>
        <div>
          @if (record.state === '200') {
            <div class="log-title">Website working again</div>
          }
          @if (record.state !== '200') {
            <div class="log-title">Website was down for {{ record.time }}</div>
          }
          <div class="log-subtitle">{{ record.eventFormatted }}</div>
        </div>
      </div>
    }
  </mat-card>
}
<ng-template #loading>
  <mat-spinner class="info-spinner" mode="indeterminate" color="accent"></mat-spinner>
</ng-template>
